<template lang="html">
    <div class="childrenBox">
        <div class="children" v-for="childrenItem in childrenArr" :key="childrenItem.service_id">
            <div class="checkBox">
                <Checkbox
                        :disabled="disabledChecked || childrenItem.is_be_overdue === 1"
                        @click="checkboxChildrenChange({
                        baseItemCode,
                        is_be_overdue: childrenItem.is_be_overdue,
                        childrenId: childrenItem.service_id,
                        dataType})" v-model="childrenItem.is_selectd" checked-color="#fd3833"></Checkbox>
            </div>
            <div class="goodsBox" @click="toServiceDetail({
                baseItemCode,
                sstore_id,
                service_id: childrenItem.service_id,
                is_selectd: childrenItem.is_selectd
            })">
                <div class="goodsImg">
                    <!-- 抽奖标志 -->
                    <i class="isLuck ico ico-icon_65" v-if="childrenItem.is_lottery === 1"></i>
                    <QualityImg :src="childrenItem.service_icon" width="140" height="140" />
                </div>
                <div class="goodsInfo">
                    <div :class="{goodsName:true, goodsName100: !hasDel}">{{ childrenItem.service_name }}</div>
                    <div class="couponTag" v-if="childrenItem.bc_coupon ">
                      <span class="item" v-for="(couponItem,index) in childrenItem.bc_coupon" :index="index" :key="index">{{couponItem}}</span>
                    </div>
                    <div class="priceBox">
                        <span class="price"><i class="flag">￥</i>{{ childrenItem.service_price }}</span>
                        <span class="discountPrice" v-if="Number(childrenItem.service_original_price) !== 0">￥{{ childrenItem.service_original_price }}</span>
                    </div>
                </div>
            </div>

            <!-- 操作按钮组（定位） -->
            <div class="goodsBtn" v-if="hasDel">
                <a href="javascript:void(0)"
                    @click="onGoodsDel({
                        baseItemCode,
                        childrenId: childrenItem.service_id,
                        dataType})"
                    class="goodsDel">删除</a>
            </div>

        </div>
    </div>
</template>
<script>
import QualityImg from '@/components/qualityImg/qualityImg.vue'
import {
    Checkbox
} from 'vant'

export default {
    name: 'itemProject',
    props: {
    /* 类型 */
        dataType: {
            type: String,
            default () {
                return 'goods'
            }
        },
        /* 保养项目编码：父组件唯一标识 */
        baseItemCode: {
            type: String,
            default () {
                return ''
            }
        },
        /* 门店id */
        sstore_id: {
            type: String,
            default () {
                return ''
            }
        },
        /* 子节点数据 */
        childrenArr: {
            type: Array,
            default () {
                return []
            }
        },
        /* 是否包含删除按钮 */
        hasDel: {
            type: Boolean,
            default () {
                return true
            }
        },
        /* 是否禁止点击复选框 */
        disabledChecked: {
            type: Boolean,
            default () {
                return false
            }
        }
    },
    components: {
        Checkbox,
        QualityImg
    },
    data () {
        return {
        }
    },
    methods: {
    /**
     * 改变复选框
     */
        checkboxChildrenChange (obj) {
            if (!(this.disabledChecked || obj.is_be_overdue === 1)) {
                this.$emit('checkboxChildrenChange', obj)
            }
        },
        /**
* 删除商品
*/
        onGoodsDel (obj) {
            this.$emit('onGoodsDel', obj)
        },
        /*
* 跳转服务详情
*/
        toServiceDetail (obj) {
            this.$emit('toServiceDetail', obj)
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
/* 修改 vant的默认样式 */
>>> .van-checkbox__icon--disabled.van-checkbox__icon--checked
  .van-icon
    color #ffffff
>>> .van-checkbox__icon--disabled
  .van-icon
    border-color #999999
    background #999999
    color #ffffff
>>> .van-stepper
  border-radius 6px
  border 1px solid #c8c8c8
  button
    background #ffffff
  input
    border-left 1px solid #c8c8c8
    border-right 1px solid #c8c8c8
    border-top none
    border-bottom none
    background #ffffff
    margin 0
    width 70px
.childrenBox
  .children
    display flex
    padding 30px 0
    position relative
    border-bottom 1px solid #efefef
    .goodsBtn
      position absolute
      top 40px
      right 30px
      .goodsDel
        font-size 23px
        line-height 23px
        color #666666
        display block
        margin-bottom 36px
      .goodsChange
        display block
        font-size 23px
        line-height 23px
        color #ff6600
    .checkBox
      width 106px
      display flex
      justify-content center
      align-items start
      padding-top 50px
    .goodsBox
      flex 1
      display flex
      .goodsImg
        width 140px
        height 140px
        margin-right 20px
        position relative
        img
          width 140px
          height 140px
        .isLuck
          position absolute
          top 0
          left 0
          z-index 10
      .goodsInfo
        width 456px
        .goodsName
          margin-right 130px
          min-height 72px
          font-size 24px
          line-height 36px
          color #666666
          mutiLineTextOverFlow()
        .goodsName100
          margin-right 30px
        .goodsTag
          margin-right 130px
          box-sizing border-box
          margin 26px 0
          .tag
            color #fc2d2d
            padding 6px 10px
            border-radius 14px
            border 1px solid #fc2d2d
            margin-right 10px
            font-size 20px
            text-align center
        .couponTag
          display flex
          margin-bottom 20px
          white-space nowrap
          width 456px
          .item
            display inline-block
            line-height 30rpx
            font-size 20px
            padding 0px 10px
            text-align center
            border-radius 6px
            border 2px solid #fc2d2d
            color #fc2d2d
            margin-left 10px
            &:first-child
              margin-left 0
            &:last-child
              overflow hidden
              white-space nowrap
              text-overflow ellipsis
        .specAndstepper
          display flex
          .goodsSpec
            width 270px
            height 54px
            box-sizing border-box
            line-height 54px
            background-color #eeeeee
            border-radius 6px
            font-size 24px
            color #3b3b3b
            padding 0 20px
            position relative
            margin-bottom 28px
            .icon
              position absolute
              top 5px
              right 15px
          .stepperBox
            flex 1
            margin-left 20px
            display inline-block
        .priceBox
          display flex
          align-content center
          .isDiscount
            margin-right 2px
          .price
            font-size 30px
            line-height 30px
            color #fc2d2d
            .flag
              font-size 24px
              font-style normal
          .discountPrice
            font-size 24px
            line-height 30px
            color #999999
            text-decoration line-through
            margin 0 20px
    .tips
      font-size 22px
      line-height 22px
      color #666666
</style>
